module.exports = __webpack_public_path__ + "static/media/eb-logo-color.419acb10.png";